import { loadPlan as planService, savePlan as planServiceSave } from '../helpers/planService';
import { updateBenchPriceOptions, updatePriceStorePrice } from './optionPricing';
import { updateGlassPrice } from './door';
import { clientCofigurationUpdated, filterAvailableLights } from './index';
import convert from '../helpers/stateToPlanConverter';
import { convertWallBasedPositioningToCoordinates } from '../helpers/stovePositionConverter';
import { updateMaterialImageOrSetPending } from './materialImage.ts'

import { clientConfigurations } from '../config.js';


export const changeSlideConfig = (slideConfig) => {
    return {
        type: 'CHANGE_SLIDE_CONFIG',
        slideConfig: slideConfig
    }

}





export const selectDesignPath = () => (dispatch, getState) => {
    dispatch({ type: 'SELECT_DESIGN_PATH' });
    dispatch(changeSlideConfig("default"));
}
export const selectOnlyContactPath = () => (dispatch, getState) => {
    dispatch({ type: 'SELECT_ONLY_CONTACT_PATH' });
    dispatch(changeSlideConfig("onlyAskBasicDetails"));
}






export const planLoading = () => {
    return { type: 'PLAN_LOADING' };
};



export const planLoaded = (plan) => {
    return ((dispatch, getState) => {
        plan.stovePosition = convertWallBasedPositioningToCoordinates(plan.StoveWall, plan.StoveFromLeft, plan.SaunaWidth, plan.SaunaDepth);
        dispatch({
            type: 'PLAN_LOADED',
            plan: plan
        });
        if (!plan.Sent) {
            if (plan.clientConfiguration) dispatch(clientCofigurationUpdated(plan.clientConfiguration));
            dispatch(renderMaterialImage());
            if (plan.baseOptions.baseBenchPrice) {
                updatePriceStorePrice(
                    {
                        brand: plan.baseOptions.benchBrand,
                        material: plan.baseOptions.benchMaterial,
                        shape: plan.baseOptions.benchShape,
                        mirrored: plan.baseOptions.mirrored,
                        profilematerial: plan.baseOptions.curvedPieces
                    }, plan.baseOptions.baseBenchPrice, getState);
            }
            dispatch(updateBenchPriceOptions());
            dispatch(updateGlassPrice());
        }
        else {
            dispatch(displayError(true, loc))

        }

    });
}

export const loadPlan = (id, securityToken) => {
    return ((dispatch) => {
        dispatch(planLoading);
        planService(id, securityToken).
            then(response => response.json()).
            then(plan => dispatch(planLoaded(plan)));
    });
};


export const savePlan = () => (dispatch, getState) => {
    dispatch({ type: 'START_PLAN_SAVING' });
    convert(getState()).
        then((planObject) => planServiceSave(planObject)).
        then((planObject) => {
            if (planObject?.id) {
                dispatch(planSaved(planObject.id, planObject.securityToken));
            }
            else
                dispatch(planSaved());
        }).
        catch(() => dispatch(saveFailed()));
}

export const planSaved = (id, securityToken) => {
    return { type: 'PLAN_SAVED', id, securityToken };
};



export const saveFailed = () => {
    return { type: 'SAVE_FAILED' }
}




export const planSent = () => {
    return { type: 'PLAN_SENT' };
};

export const toggleBench = (stove) => {
    return ((dispatch) => {
        dispatch({
            type: 'TOGGLE_BENCH'
        });
        dispatch(productsChanged());
        dispatch(updateMaterialImageOrSetPending());
    });
}


export const productsChanged = () => (dispatch, getState) => {
    let plan = getState().plan;
    dispatch({
        type: 'PRODUCTS_CHANGED',
        products: plan
    });
    dispatch(filterAvailableLights());
};
export const setRequestResellerAssistance = (value) => {
    return {
        type: 'RESELLER_ASSISTANCE_CHANGED',
        value: value
    }

}





export const newPlan = () => {
    return { type: 'NEW_PLAN' };
};

export const toggleDoor = () => {
    return { type: 'TOGGLE_DOOR' };
};
export const togglePaneling = () => {
    return { type: 'TOGGLE_PANELING' };
};
export const toggleLights = () => {
    return { type: 'TOGGLE_LIGHTS' };
};
export const toggleStove = () => {
    return { type: 'TOGGLE_STOVE' };
};
export const setSellerId = (sellerId) => {
    return {
        type: 'CHANGE_SELLERID',
        sellerId: sellerId
    }

}


